(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["topswings-welcome-style"] && !Shopify.designMode) return;
  try {
    const offerStyles = `
[data-testid="form-teaser"], button[aria-haspopup="dialog"][aria-label="10% OFF"] {
  background: #e00025 !important;
  color: #ffffff !important;
  border: 0 !important;
  border-radius: 999px !important;
  padding: 14px 22px !important;
  box-shadow: 0 4px 18px rgb(0 0 0 / 12%) !important;
}
[data-testid="form-teaser"] h3, button[aria-label="10% OFF"] h3 {
  color: #ffffff !important;
  font-size: 20px !important;
  font-weight: 500 !important;
  line-height: 1.2 !important;
}
[data-testid="form-teaser"] [aria-label="Close modal"] {
  color: #ffffff !important;
  opacity: 1 !important;
}
[data-testid="form-teaser"] svg {
  fill: currentColor !important;
  width: 16px !important;
  height: 16px !important;
}
h2 {
  color: #bf3032 !important;
  font-size: 36px !important;
  line-height: 1.12 !important;
  font-weight: 700 !important;
}
button[type="submit"], form button:not([aria-label]) {
  background: #bf3032 !important;
  color: #ffffff !important;
  border-radius: 999px !important;
}
input[type="email"] {
  border-radius: 999px !important;
}
`;
const styledRoots = new WeakSet();
const installOfferStyle = () => {
  document.querySelectorAll('[id^="app-embed-container-"], form-embed, shopify-forms-embed, [data-forms-id="forms-root-1195172"]').forEach(host => {
    const root = host.shadowRoot;
    if (!root || styledRoots.has(root)) return;
    if (!host.id.includes('1195172') && !host.closest('[data-forms-id="forms-root-1195172"]') && !root.querySelector('[aria-label="10% OFF"], [aria-label="SAVE UP TO 10%"]')) return;
    const style = document.createElement('style');
    style.textContent = offerStyles;
    root.appendChild(style);
    styledRoots.add(root);
  });
};
let offerFrame = 0;
const scheduleOfferStyle = () => {
  if (offerFrame) return;
  offerFrame = requestAnimationFrame(() => {
    offerFrame = 0;
    installOfferStyle();
  });
};
new MutationObserver(scheduleOfferStyle).observe(document.body, { childList: true, subtree: true });
installOfferStyle();
let offerAttempts = 0;
const offerTimer = setInterval(() => {
  installOfferStyle();
  if (++offerAttempts >= 30 || styledRoots.has(document.querySelector('#app-embed-container-1195172')?.shadowRoot)) clearInterval(offerTimer);
}, 1000);
  } catch(e) { console.error(e); }
})();

})();
